import TableComponent from "../../components/TableComponent";

type props = {
  columns: any;
  rows: any;
  count: number;
  page: number;
  onPageChange: (event: any, newPage: number) => void;
  loading: boolean;
};

const NewIndividualsList = ({
  rows,
  columns,

  count,
  page,
  onPageChange,
  loading,
}: props) => {
  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default NewIndividualsList;
